import { useConfigStore } from '~/stores/config';

export const useOnboardingClusterOptions = () => {
  const configStore = useConfigStore();

  const countryStates = computed(() =>
    (configStore.cluster?.country?.states ?? []).map(state => ({ label: state.name, value: state.id })),
  );

  // The server owns the rule (US opt-out states start ticked); an unknown or missing state starts empty.
  const marketingBoxStartsTicked = (stateId?: string | null): boolean =>
    (configStore.cluster?.country?.states ?? []).find(state => state.id === stateId)?.marketingBoxStartsTicked ?? false;

  return { countryStates, marketingBoxStartsTicked };
};
